import { render, staticRenderFns } from "./RelativeRelationTypeChangeActivationType.vue?vue&type=template&id=0396c748&"
import script from "./RelativeRelationTypeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports